import { combineReducers } from 'redux';
import alertReducer from './alert';
import authReducer from './auth';
import globalReducer from './global';
import progressAlertReducer from './progressAlert';
import uploadReducer from './upload';

export default combineReducers({
  alert: alertReducer,
  progressAlert: progressAlertReducer,
  global: globalReducer,
  auth: authReducer,
  upload: uploadReducer,
});
